export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBQkAGbU6HLuj8QfVN0MfGZUsHycErJa08',
    authDomain: 'giovannisullipt.firebaseapp.com',
    databaseURL: 'https://giovannisullipt.firebaseio.com',
    projectId: 'giovannisullipt',
    storageBucket: 'giovannisullipt.appspot.com',
    messagingSenderId: '306848433435',
    appId: '1:306848433435:web:8f806ccc60653440a6ffbe',
    measurementId: 'G-JJ8937N4QB'

  }
};
